"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const PT = __importStar(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const nav_frontend_js_utils_1 = require("nav-frontend-js-utils");
const toggle_knapp_pure_1 = __importStar(require("./toggle-knapp-pure"));
require("nav-frontend-toggle-style");
class ToggleGruppePure extends React.PureComponent {
    render() {
        const renderProps = (0, nav_frontend_js_utils_1.omit)(this.props, "className", "children", "kompakt", "toggles", "defaultToggles");
        return (React.createElement("div", Object.assign({ className: (0, classnames_1.default)("toggleGruppe", this.props.className) }, renderProps), this.props.toggles.map((toggle, i) => (React.createElement(toggle_knapp_pure_1.default, Object.assign({ key: (0, nav_frontend_js_utils_1.guid)(), kompakt: this.props.kompakt }, toggle))))));
    }
}
ToggleGruppePure.propTypes = {
    /**
     * Array av toggle knapper, se `toggle-knapp-pure.tsx`
     */
    toggles: PT.arrayOf(toggle_knapp_pure_1.ToggleKnappPurePropsShape).isRequired,
    /**
     * Egendefinert klassenavn.
     */
    className: PT.string,
    /**
     * Hvis 'true' reduseres høyre/venstre-padding på knappene betraktelig.
     */
    kompakt: PT.bool,
};
exports.default = ToggleGruppePure;
